import { useMutation, useQueryClient } from '@tanstack/react-query';
import { markNotificationsRead } from '@dc-trans/data-layer';

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ulids: string[]) => markNotificationsRead(ulids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
